module.exports = __webpack_public_path__ + "img/folder-icon.83df51af.svg";